import { __assign, __awaiter, __generator } from "tslib";
import { getAdminConstructionApiUrl } from "@adsk/acs-sc-web-platform-api";
import fetcherWithRegionHeader from "../../utils/fetcherWithRegionHeader";
import { TemplateCreateType } from "../../shared/types";
export var createProject = function (props) {
  return __awaiter(void 0, void 0, void 0, function () {
    var createTemplateRequestBody;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          createTemplateRequestBody = __assign(
            {
              name: props.name,
              type: "Template Project",
              platform: props.platform,
              classification: "template",
            },
            props.type === TemplateCreateType.FromProject
              ? {
                  template: {
                    projectId: props.projectId,
                  },
                }
              : undefined
          );
          return [
            4 /*yield*/,
            fetcherWithRegionHeader(
              ""
                .concat(getAdminConstructionApiUrl(), "/v1/accounts/")
                .concat(props.accountId, "/projects"),
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(createTemplateRequestBody),
              }
            ),
          ];
        case 1:
          // Send the API request to createProject
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
